<ol
  *ngIf="steps.length > 0"
  class="cg-process-steps"
  data-test="component-process-steps"
>
  <li
    *ngFor="let step of steps; let i = index"
    [class.cg-display-none]="hiddenSteps.includes(i)"
    class="cg-process-steps__item"
    [attr.data-test]="i === activeStep ? 'active-step' : 'step'"
    [class.cg-process-steps__item--active]="i === activeStep"
    [class.cg-process-steps__item--completed]="i < activeStep"
  >
    {{ step }}
  </li>
</ol>
